let testimonialFlkty;

function setEqualHeights() {
	const cells = document.querySelectorAll('.testimonial__cell');
	if (cells.length === 0) return;

	// Reset heights to auto to get natural height
	cells.forEach(cell => {
		cell.style.height = 'auto';
	});

	// Get the tallest height
	let maxHeight = 0;
	cells.forEach(cell => {
		const height = cell.offsetHeight;
		if (height > maxHeight) {
			maxHeight = height;
		}
	});

	// Set all cells to the max height
	cells.forEach(cell => {
		cell.style.height = maxHeight + 'px';
	});
}

function initTestimonialSlider() {
	const slider = document.querySelector(".testimonial .testimonial__slider");
	if (!slider) return null;

	if (slider.classList.contains("flickity-enabled")) {
		// If it's already initialized but potentially broken, destroy and reinitialize
		const existingFlickity = Flickity.data(slider);
		if (existingFlickity) existingFlickity.destroy();
	}

	try {
		const flkty = new Flickity(slider, {
			cellAlign: "left",
			contain: true,
			groupCells: 1,
			pageDots: false,
			prevNextButtons: true,
			draggable: true,
			wrapAround: false,
			percentPosition: true,
			freeScroll: false,
			rightToLeft: false,
		});

		// Store the reference globally
		testimonialFlkty = flkty;

		// Set equal heights after Flickity is ready
		flkty.on('ready', function() {
			setTimeout(setEqualHeights, 100);
		});

		// Also set equal heights when slider settles after any interaction
		flkty.on('settle', function() {
			setTimeout(setEqualHeights, 50);
		});

		return flkty;
	} catch (error) {
		console.error("Error initializing Flickity:", error);
		return null;
	}
}

// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", function () {
	// Try to initialize immediately
	const initialFlkty = initTestimonialSlider();

	// If initialization failed or slider wasn't ready, retry with a small delay
	if (!initialFlkty) {
		setTimeout(initTestimonialSlider, 500);
	}
});

// Also initialize on window.onload to ensure all resources are loaded
window.addEventListener("load", function () {
	// If the slider exists but isn't properly initialized, reinitialize it
	const slider = document.querySelector(".testimonial .testimonial__slider");
	if (
		slider &&
		(!testimonialFlkty || !slider.classList.contains("flickity-enabled"))
	) {
		initTestimonialSlider();
	}

	if (testimonialFlkty) {
		setTimeout(() => {
			testimonialFlkty.resize();
			setEqualHeights();
		}, 100);
	}
});

// Shopify customizer events to handle slider reinitialization
document.addEventListener("shopify:section:load", function (event) {
	if (event.target.querySelector(".testimonial .testimonial__slider")) {
		setTimeout(initTestimonialSlider, 100);
	}
});

document.addEventListener("shopify:section:reorder", function (event) {
	if (event.target.querySelector(".testimonial .testimonial__slider")) {
		setTimeout(initTestimonialSlider, 100);
	}
});

document.addEventListener("shopify:section:select", function (event) {
	if (event.target.querySelector(".testimonial .testimonial__slider")) {
		setTimeout(() => {
			if (testimonialFlkty) {
				testimonialFlkty.resize();
				setEqualHeights();
			}
		}, 100);
	}
});

document.addEventListener("shopify:section:deselect", function (event) {
	if (event.target.querySelector(".testimonial .testimonial__slider")) {
		setTimeout(() => {
			if (testimonialFlkty) {
				testimonialFlkty.resize();
				setEqualHeights();
			}
		}, 100);
	}
});

document.addEventListener("shopify:block:select", function (event) {
	const slider = document.querySelector(".testimonial .testimonial__slider");
	if (slider && slider.contains(event.target)) {
		setTimeout(() => {
			if (testimonialFlkty) {
				testimonialFlkty.resize();
				setEqualHeights();
			}
		}, 100);
	}
});

document.addEventListener("shopify:block:deselect", function (event) {
	const slider = document.querySelector(".testimonial .testimonial__slider");
	if (slider && slider.contains(event.target)) {
		setTimeout(() => {
			if (testimonialFlkty) {
				testimonialFlkty.resize();
				setEqualHeights();
			}
		}, 100);
	}
});
